export default {
    Helvetica: 'Helvetica',
};
